        <template>
  <b-card>
    <b-row
          >
                                    <b-col
                                                                                      sm="3"
                                        >
                            <date-input
  id="xparam2"
  name="xparam2"
    :value.sync="xparam2"
    label="Период: с"
  api=""
  subtract="-1 month"
  rules=""
/>            </b-col>
                                        <b-col
                                                                                      sm="3"
                                        >
                            <date-input
  id="xparam3"
  name="xparam3"
    :value.sync="xparam3"
    label="по"
  api=""
  subtract=""
  rules=""
/>            </b-col>
                                        <b-col
                                                                                                >
              <div
                                class="d-flex justify-content-end pt-2"
                              >
                                  <div
                                        >
                                            <refresh-button
  label="Обновить"
  :refresh.sync="refresh"
    variant="outline-primary"
      />                  </div>
                              </div>
            </b-col>
                                        <b-col
                                                                                      sm="12"
                                        >
                            <basic-table
  :columns="[{&quot;key&quot;:&quot;refer&quot;,&quot;label&quot;:&quot;\u041e\u0442\u043a\u0443\u0434\u0430&quot;,&quot;sortable&quot;:false,&quot;thClass&quot;:&quot;text-center&quot;,&quot;expand&quot;:{&quot;tabs&quot;:[{&quot;title&quot;:&quot;\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438&quot;,&quot;content&quot;:&quot;table&quot;,&quot;api&quot;:&quot;https:\/\/api.Кавказский стиль.ru\/api\/v1\/json\/lk\/refer\/link\/xgrid\/buyer&quot;,&quot;hidePagination&quot;:true,&quot;columns&quot;:[{&quot;key&quot;:&quot;buyerC&quot;,&quot;sortable&quot;:false,&quot;label&quot;:&quot;\u041d\u043e\u043c\u0435\u0440&quot;,&quot;thClass&quot;:&quot;text-center&quot;,&quot;tdClass&quot;:&quot;text-right&quot;},{&quot;key&quot;:&quot;FIO&quot;,&quot;sortable&quot;:false,&quot;label&quot;:&quot;\u0424\u0418\u041e&quot;,&quot;thClass&quot;:&quot;text-center&quot;},{&quot;key&quot;:&quot;date&quot;,&quot;sortable&quot;:false,&quot;label&quot;:&quot;\u0414\u0430\u0442\u0430 \u0440\u0435\u0433.&quot;,&quot;thClass&quot;:&quot;text-center&quot;,&quot;tdClass&quot;:&quot;text-center&quot;},{&quot;key&quot;:&quot;town_name&quot;,&quot;sortable&quot;:false,&quot;label&quot;:&quot;\u0413\u043e\u0440\u043e\u0434&quot;,&quot;thClass&quot;:&quot;text-center&quot;},{&quot;key&quot;:&quot;inpt_name&quot;,&quot;sortable&quot;:false,&quot;label&quot;:&quot;\u0412\u0445\u043e\u0434&quot;,&quot;thClass&quot;:&quot;text-center&quot;}]},{&quot;title&quot;:&quot;\u0417\u0430\u043a\u0430\u0437\u044b&quot;,&quot;content&quot;:&quot;table&quot;,&quot;api&quot;:&quot;https:\/\/api.Кавказский стиль.ru\/api\/v1\/json\/lk\/refer\/link\/grid\/inv&quot;,&quot;hidePagination&quot;:true,&quot;columns&quot;:[{&quot;key&quot;:&quot;id&quot;,&quot;sortable&quot;:false,&quot;label&quot;:&quot;\u2116&quot;,&quot;thClass&quot;:&quot;text-center&quot;,&quot;tdClass&quot;:&quot;text-right&quot;},{&quot;key&quot;:&quot;date&quot;,&quot;sortable&quot;:false,&quot;label&quot;:&quot;\u0414\u0430\u0442\u0430&quot;,&quot;thClass&quot;:&quot;text-center&quot;,&quot;tdClass&quot;:&quot;text-center&quot;},{&quot;key&quot;:&quot;FIO&quot;,&quot;sortable&quot;:false,&quot;label&quot;:&quot;\u0424\u0418\u041e&quot;,&quot;thClass&quot;:&quot;text-center&quot;},{&quot;key&quot;:&quot;sumBall&quot;,&quot;sortable&quot;:false,&quot;label&quot;:&quot;\u0421\u0443\u043c\u043c\u0430, \u0431\u0430\u043b&quot;,&quot;thClass&quot;:&quot;text-center&quot;,&quot;tdClass&quot;:&quot;text-right&quot;},{&quot;key&quot;:&quot;status&quot;,&quot;sortable&quot;:false,&quot;label&quot;:&quot;\u0421\u0442\u0430\u0442\u0443\u0441&quot;,&quot;thClass&quot;:&quot;text-center&quot;}]}]}},{&quot;key&quot;:&quot;domain_name&quot;,&quot;label&quot;:&quot;\u041a\u0443\u0434\u0430&quot;,&quot;sortable&quot;:false,&quot;thClass&quot;:&quot;text-center&quot;},{&quot;key&quot;:&quot;sType&quot;,&quot;label&quot;:&quot;\u0422\u0438\u043f&quot;,&quot;sortable&quot;:false,&quot;thClass&quot;:&quot;text-center&quot;},{&quot;key&quot;:&quot;lastDate&quot;,&quot;label&quot;:&quot;\u041c\u0430\u043a\u0441. \u0434\u0430\u0442\u0430&quot;,&quot;sortable&quot;:false,&quot;thClass&quot;:&quot;text-center&quot;,&quot;tdClass&quot;:&quot;text-center&quot;},{&quot;key&quot;:&quot;cntAll&quot;,&quot;label&quot;:&quot;\u041a\u043e\u043b-\u0432\u043e \u043f\u0440\u043e\u0441\u043c\u043e\u0442\u0440\u043e\u0432&quot;,&quot;sortable&quot;:false,&quot;thClass&quot;:&quot;text-center&quot;,&quot;tdClass&quot;:&quot;text-right&quot;},{&quot;key&quot;:&quot;cntUser&quot;,&quot;label&quot;:&quot;\u041a\u043e\u043b-\u0432\u043e \u0432\u0438\u0437\u0438\u0442\u043e\u0432&quot;,&quot;sortable&quot;:false,&quot;thClass&quot;:&quot;text-center&quot;,&quot;tdClass&quot;:&quot;text-right&quot;},{&quot;key&quot;:&quot;cntReg&quot;,&quot;label&quot;:&quot;\u041a\u043e\u043b-\u0432\u043e \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0439&quot;,&quot;sortable&quot;:false,&quot;thClass&quot;:&quot;text-center&quot;,&quot;tdClass&quot;:&quot;text-right&quot;},{&quot;key&quot;:&quot;cntOrder&quot;,&quot;label&quot;:&quot;\u041a\u043e\u043b-\u0432\u043e \u0437\u0430\u043a\u0430\u0437\u043e\u0432&quot;,&quot;sortable&quot;:false,&quot;thClass&quot;:&quot;text-center&quot;,&quot;tdClass&quot;:&quot;text-right&quot;}]"
          :refresh="refresh"
          :xparam2="xparam2"
      :xparam3="xparam3"
                            api="https://api.Кавказский стиль.ru/api/v1/json/lk/refer/link/grid"
          />            </b-col>
                            </b-row>
  </b-card>
</template>
<script>
/* eslint-disable */
// prettier-ignore
import {
  BCard,
  BRow,
  BCol,
} from 'bootstrap-vue'

import { ref } from '@vue/composition-api'

                                      import DateInput from '@core/components/input/date-input/DateInput.vue'
                                                                                                  import RefreshButton from '@core/components/button/RefreshButton.vue'
                                                                          import BasicTable from '@core/components/table/basic-table/BasicTable.vue'
                            
export default {
  components: {
    BCard,
    BRow,
    BCol,

                                                          DateInput,
                                                                                                                              RefreshButton,
                                                                                            BasicTable,
                                          },
  setup() {
                const xparam2 = ref()
            const xparam3 = ref()
            const refresh = ref(false)
          
          return {
            xparam2,
            xparam3,
            refresh,
            }
      },
}
</script>
    